module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/image-5-b7f7c35928064b070e804a00edfa9111.png";